/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import objectPath from "object-path";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../_helpers";
import { AsideSearch } from "./AsideSearch";
import { AsideMenu } from "./aside-menu/AsideMenu";
import { LanguageSelectorDropdown } from "../extras/dropdowns/LanguageSelectorDropdown";
import { QuickUserToggler } from "../extras/QuickUserToggler";
import { Brand } from "../brand/Brand";
import { KTUtil } from "./../../../_assets/js/components/util";
import { AESVG } from "../../../../_emywork/components/svg";
import { getMenu } from "../../../../_emywork/UIMenu";
import { useSelector } from "react-redux";
import { getConfig } from "../../../i18n";
import { AEOverlayTrigger } from "../../../../_emywork/AEOverlayTrigger";
import { Link, useLocation } from "react-router-dom";
import { useIntl } from "react-intl";
import { roles } from "../../../../index";


export function Aside() {
  const uiService = useHtmlClassService();
  const location = useLocation()
  const { formatMessage } = useIntl()
  // const {user} = useSelector(state => state.auth);
  const [MENU, setMenu] = useState([]);
  const emyworkErp = formatMessage({ id: "EMYWORK.ERP" })
  const emyworkErpLang = formatMessage({ id: "EMYWORK.ERP.LANG" })
  const emyworkLinks = formatMessage({ id: "EMYWORK.LINK" })


  const { role } = getConfig()

  const layoutProps = useMemo(() => {
    return {
      asideClassesFromConfig: uiService.getClasses("aside", true),
      asideSecondaryDisplay: objectPath.get(
        uiService.config,
        "aside.secondary.display"
      ),
      asideSelfMinimizeToggle: objectPath.get(
        uiService.config,
        "aside.self.minimize.toggle"
      ),
      extrasSearchDisplay: objectPath.get(
        uiService.config,
        "extras.search.display"
      ),
      extrasNotificationsDisplay: objectPath.get(
        uiService.config,
        "extras.notifications.display"
      ),
      extrasQuickActionsDisplay: objectPath.get(
        uiService.config,
        "extras.quick-actions.display"
      ),
      extrasQuickPanelDisplay: objectPath.get(
        uiService.config,
        "extras.quick-panel.display"
      ),
      extrasLanguagesDisplay: objectPath.get(
        uiService.config,
        "extras.languages.display"
      ),
      extrasUserDisplay: objectPath.get(
        uiService.config,
        "extras.user.display"
      ),
    };
  }, [uiService]);


  // const [activeTab, setActiveTab] = useState("dashboard");
  // const handleTabChange = (id) => {
  //   setActiveTab(id);
  //   const asideWorkspace = KTUtil.find(
  //     document.getElementById("kt_aside"),
  //     ".aside-secondary .aside-workspace"
  //   );
  //   if (asideWorkspace) {
  //     KTUtil.scrollUpdate(asideWorkspace);
  //   }
  // };

  const closeMenu = () => {
    document.body.classList.add("aside-minimize")
  }
  const openMenu = () => {
    document.body.classList.remove("aside-minimize")
  }

  // useEffect(()=>{
  //   const menuI = MENU.findIndex(m=>m.id === activeTab);
  //   // console.log(menuI, activeTab)
  //   if(menuI !== -1){
  //     const menu = MENU[menuI];
  //     // console.log("menu",menu)
  //
  //     if(menu.hasChildren()) closeMenu()
  //     else openMenu()
  //
  //   }
  // },[MENU, activeTab])

  useEffect(() => {
    setMenu(getMenu(role))
  }, [role, formatMessage])


  return (
    <>
      {/* begin::Aside */}
      <div
        id="kt_aside"
        className={`aside aside-left d-flex ${layoutProps.asideClassesFromConfig} ${role === roles.super_admin ? 'bg-secondary' : ''}`}
      >
        {/* begin::Primary */}
        <div className="aside-primary d-flex flex-column align-items-center flex-row-auto">
          <Brand />
          {/* begin::Nav Wrapper */}
          <div className="aside-nav d-flex flex-column align-items-center flex-column-fluid py-5 scroll scroll-pull">
            {/* begin::Nav */}
            <ul className="list-unstyled flex-column" role="tablist">

              {
                MENU.map((menu, index) => {
                  const { svg, route_path } = menu;
                  const title = formatMessage({ id: menu.title })
                  const active = location.pathname.includes(route_path);
                  // if(active) console.log(location, route_path)
                  return (
                    <li
                      key={index}
                      className="nav-item mb-3 btn-hover-info svg-icon"
                      // data-toggle="tooltip"
                      // data-placement="right"
                      // data-container="body"
                      // data-boundary="window"
                      title={title}
                    >
                      <AEOverlayTrigger
                        overlay={<Tooltip id={`tooltip_${index}`}>{title}</Tooltip>}
                      >
                        <Link
                          to={route_path}
                          // className={`nav-link btn btn-icon btn-clean text-hover-info btn-lg ${activeTab === id && "active"} `}
                          className={`nav-link btn btn-icon btn-clean text-hover-info btn-lg ${active ? 'active' : ''}`}
                        // data-toggle="tab"
                        // data-target={`#${id}`}
                        // role="tab"
                        // onClick={() => handleTabChange(id)}
                        >
                          <AESVG path={svg} className={'btn-hover-danger'} size={'2x'} />
                        </Link>
                      </AEOverlayTrigger>
                    </li>
                  )
                }
                )
              }


              <li
                className="nav-item mb-3 btn-hover-info svg-icon"
                title={'8x8 Meet'}
              >
                <AEOverlayTrigger
                  overlay={<Tooltip id={`tooltip_8x8`}>{'8x8 Meet'}</Tooltip>}
                >
                  <a
                    href={'https://meet.jit.si/'}
                    className={'nav-link btn btn-icon btn-clean text-hover-info btn-lg'}
                    target={'_blank'}
                  >
                    <span className="svg-icon svg-icon-lg">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.21636 22.0552L4.89942 22.0552C5.31044 22.0552 5.69358 21.8473 5.91758 21.5026L10.8222 13.957L9.0596 11.2453C8.34129 10.1402 6.72341 10.1402 6.0051 11.2453L0.19819 20.179C-0.326914 20.9869 0.252843 22.0552 1.21636 22.0552Z" fill="#CB2233" />
                        <path d="M9.56499 22.0552L13.248 22.0552C13.6591 22.0552 14.0422 21.8473 14.2662 21.5026L19.1709 13.957L17.4082 11.2453C16.6899 10.1402 15.072 10.1402 14.3537 11.2453L8.54682 20.179C8.02172 20.9869 8.60148 22.0552 9.56499 22.0552Z" fill="#CB2233" />
                        <path d="M23.544 22.0994H19.5379C18.5207 22.0994 17.5704 21.5923 17.0041 20.7474C16.8769 20.5577 16.8748 20.3106 16.9987 20.1187L19.6509 16.0103C19.8298 15.7332 20.2349 15.7323 20.415 16.0087L23.9255 21.3954C24.1229 21.6983 23.9056 22.0994 23.544 22.0994Z" fill="url(#paint0_linear)" />
                        <circle cx="7.46175" cy="4.28987" r="3.28987" fill="#CB2233" />
                        <circle cx="15.557" cy="4.28987" r="3.28987" fill="#CB2233" />
                        <defs>
                          <linearGradient id="paint0_linear" x1="20.746" y1="19.575" x2="18.8048" y2="17.7249" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#CB2233" />
                            <stop offset="1" stopColor="#910000" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </span>
                  </a>
                </AEOverlayTrigger>
              </li>

              {/* erp.emywork.ma */}
              <li
                className="nav-item mb-3 btn-hover-info svg-icon"
                title={emyworkErp}
              >
                <AEOverlayTrigger
                  overlay={<Tooltip id={`erp_emywork`}>{emyworkErp}</Tooltip>}
                >
                  <a
                    href={`https://erp.emywork.ma/login/${emyworkErpLang}`}
                    className={'nav-link btn btn-icon btn-clean text-hover-info btn-lg'}
                    target={'_blank'}
                  >
                    <span className="svg-icon svg-icon-lg btn-hover-danger svg-icon menu-icon svg-icon-2x">
                      <i className="fa fa-solid fa-cubes"></i>
                    </span>
                  </a>
                </AEOverlayTrigger>
              </li>

              {/* emywork.ma */}
              <li
                className="nav-item mb-3 btn-hover-info svg-icon"
                title={emyworkLinks}
              >
                <AEOverlayTrigger
                  overlay={<Tooltip id={`emywork_ma`}>{emyworkLinks}</Tooltip>}
                >
                  <a
                    href={'https://linktr.ee/emywork'}
                    className={'nav-link btn btn-icon btn-clean text-hover-info btn-lg'}
                    target={'_blank'}
                  >
                    <span className="svg-icon svg-icon-lg btn-hover-danger svg-icon menu-icon svg-icon-2x">
                    <i className="fa fa-solid fa-briefcase"></i>
                    </span>
                  </a>
                </AEOverlayTrigger>
              </li>

            </ul>
            {/* end::Nav */}
          </div>
          {/* end::Nav Wrapper */}

          {/* begin::Footer */}
          <div className="aside-footer d-flex flex-column align-items-center flex-column-auto -py-4 -py-lg-10">
            {/* begin::Aside Toggle */}

            {layoutProps.asideSecondaryDisplay &&
              layoutProps.asideSelfMinimizeToggle && (
                <>
                  <AEOverlayTrigger
                    overlay={<Tooltip id="toggle-aside">Toggle Aside</Tooltip>}
                  >
                    <span
                      className="aside-toggle btn btn-icon btn-primary btn-hover-primary shadow-sm"
                      id="kt_aside_toggle"
                    // onClick={event => {
                    //   openMenu()
                    // }}

                    >
                      <i className="ki ki-bold-arrow-back icon-sm" />
                    </span>
                  </AEOverlayTrigger>
                </>
              )}
            {/* end::Aside Toggle */}

            {/* begin::Search */}
            {layoutProps.extrasSearchDisplay && (
              <AEOverlayTrigger
                overlay={<Tooltip id="toggle-search">{formatMessage({ id: 'QUICK_SEARCH' })}</Tooltip>}
              >
                <a
                  href="#"
                  className="btn btn-icon btn-clean btn-lg mb-1"
                  id="kt_quick_search_toggle"
                >
                  <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")}
                    />
                  </span>
                </a>
              </AEOverlayTrigger>
            )}
            {/* end::Search */}

            {/* begin::Notifications */}
            {layoutProps.extrasNotificationsDisplay && (
              <AEOverlayTrigger
                overlay={
                  <Tooltip id="toggle-notifications">{formatMessage({ id: "Notifications" })}</Tooltip>
                }
              >
                <a
                  href="#"
                  className="btn btn-icon btn-clean btn-lg mb-1 position-relative"
                  id="kt_quick_notifications_toggle"
                  data-placement="right"
                  data-container="body"
                  data-boundary="window"
                >
                  <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                    />
                  </span>
                </a>
              </AEOverlayTrigger>
            )}
            {/* end::Notifications */}

            {/* begin::Quick Actions */}
            {layoutProps.extrasQuickActionsDisplay && (
              <AEOverlayTrigger
                overlay={
                  <Tooltip id="toggle-quick-actions">Quick Actions</Tooltip>
                }
              >
                <a
                  href="#"
                  className="btn btn-icon btn-clean btn-lg mb-1"
                  id="kt_quick_actions_toggle"
                >
                  <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Media/Equalizer.svg"
                      )}
                    />
                  </span>
                </a>
              </AEOverlayTrigger>
            )}
            {/* end::Quick Actions */}

            {/*begin::Quick Panel */}
            {layoutProps.extrasQuickPanelDisplay && (
              <AEOverlayTrigger
                overlay={<Tooltip id="toggle-quick-panel">{formatMessage({ id: 'QUICK_PANEL' })}</Tooltip>}
              >
                <a
                  href="#"
                  className="btn btn-icon btn-clean btn-lg mb-1 position-relative"
                  id="kt_quick_panel_toggle"
                  data-placement="right"
                  data-container="body"
                  data-boundary="window"
                >
                  <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Layout/Layout-4-blocks.svg"
                      )}
                    />
                  </span>
                  <span className="label label-sm label-light-danger label-rounded font-weight-bolder position-absolute top-0 right-0 mt-1 mr-1">
                    3
                  </span>
                </a>
              </AEOverlayTrigger>
            )}
            {/*end::Quick Panel */}

            {/* begin::Languages*/}
            {/*{layoutProps.extrasLanguagesDisplay && <LanguageSelectorDropdown />}*/}
            {/* end::Languages */}

            {/* begin::User*/}
            {/*{layoutProps.extrasUserDisplay && <QuickUserToggler />}*/}
            {/* end::User */}
          </div>
          {/* end::Footer */}
        </div>
        {/* end::Primary */}

        {layoutProps.asideSecondaryDisplay && (
          <>
            {/* begin::Secondary */}
            <div className="aside-secondary d-flex flex-row-fluid">
              {/* begin::Workspace */}
              <div className="aside-workspace scroll scroll-push my-2">
                <div className="tab-content">
                  {/*<AsideSearch isActive={activeTab === tabs.tabId1} />*/}
                  {
                    // MENU.map(({id, children})=>(
                    //   <AsideMenu
                    //     key={id}
                    //     isActive={activeTab === id}
                    //     childMenu={children}
                    //   />
                    // ))
                  }
                </div>
              </div>
              {/* end::Workspace */}
            </div>
            {/* end::Secondary */}
          </>
        )}
      </div>
      {/* end::Aside */}
    </>
  );
}
